import Component from './Component';
import Dropdown from './Dropdown';
import axios from 'axios';
import { togglePreloader } from './../services/ScrollResizeHandler';
import { renderKLTemp, noResultsTemp } from './../services/Templates';
import { filterArray } from './../utilities/filter_array';

/**
 * --------------------------------------------------------------------------------------------
 * PRIVATE VARIABLES
 * --------------------------------------------------------------------------------------------
 */
 let newPromise;
 let mapping = new Map();
 let currPage = 1;
 let maxPage = 1;
 let newURL;



/**
 * --------------------------------------------------------------------------------------------
 * HELPER FUNCTIONS
 * --------------------------------------------------------------------------------------------
 */







/**
 * --------------------------------------------------------------------------------------------
 * EXPORTS
 * --------------------------------------------------------------------------------------------
 */



export default class KnowledgeLibrary extends Component {

    decorator () {
        return {
            selector : '.js-knowledge-library',
            name : 'KnowledgeLibrary',
        }
    }


    constructor(element) {
        super(element);

        // INITIAL CALLS
        this.cacheElements();

        // BIND ELEMENTS
        this.bindElements();

        // LOAD ARTICLES
        this.loadDefaultArticles();
    }


    cacheElements () {
        this.categoryItem = Array.from(this.element.querySelectorAll('.js-kl-category'));
        this.toggleFilter = this.element.querySelector('.js-kl-toggle-filter');
        this.container = this.element.querySelector('.js-kl-container');
        this.clear = this.element.querySelector('.js-kl-clear');
        this.pagination = this.element.querySelector('.js-kl-pagination');
        this.paginate = Array.from(this.pagination.querySelectorAll('.js-paginate'));
        this.current = this.pagination.querySelector('.js-current');
        this.total = this.pagination.querySelector('.js-total');
        this.formatDropdown = Dropdown.prototype.collection[0].$element;
        this.categoryDropdown = Dropdown.prototype.collection[1].$element;

        this.current.innerHTML = 1;
        this.total.innerHTML = maxPage;

        const initPromise = axios.get('/api/article-list/knowledge-library')
            .then(response => {
                return response.data;
            })
            .then(data => {
                maxPage = data.last_page;
                this.total.innerHTML = maxPage;
                this.disablePagination(currPage, maxPage);
            })
            .catch(error => {
                console.error(error);
            })

    }


    bindElements () {

        this.categoryItem.forEach(item => {
            item.addEventListener('click', e => {
                e.preventDefault();
                this.handleSelection(item)
            });
        });



        // FORMAT DROPDOWN
        this.formatDropdown.on('change', e => {
            let _val = this.formatDropdown.val();
            togglePreloader();

            mapping.set('format', _val);

            if (_val == '') { mapping.delete('format'); }

            setTimeout(() => {
                if (mapping.size > 0) {
                    this.filterArticle(mapping);
                } else {
                    newURL = null;
                    this.loadArticles(1);
                }
            }, 350);
        });



        // CATEGORY DROPDOWN
        this.categoryDropdown.on('change', e => {
            let _val = this.categoryDropdown.val();

            togglePreloader();

            mapping.set('category', _val);

            if (_val == '') { mapping.delete('category'); }

            setTimeout(() => {
                if (mapping.size > 0) {
                    this.filterArticle(mapping);
                } else {
                    newURL = null;
                    this.loadArticles(0);
                }
            }, 350);

            this.categoryItem.forEach(node => {
                node.classList.remove('is-selected');

                if (node.getAttribute('data-filter-id') == _val) {
                    node.classList.add('is-selected');
                }
            });
        });


        // SHOW/HIDE FILTER DROPDOWN
        this.toggleFilter.addEventListener('click', e => {
            e.preventDefault();

            if (!this.toggleFilter.classList.contains('is-active')) {
                this.toggleFilter.classList.add('is-active');
            } else {
                this.toggleFilter.classList.remove('is-active');
            }
        });


        // CLEAR FILTER
        this.clear.addEventListener('click', e => {
            e.preventDefault();

            if (this.categoryDropdown.val() != '') {
                this.categoryDropdown.val('').trigger('change');
            }

            if (this.formatDropdown.val() != '') {
                this.formatDropdown.val('').trigger('change');
            }
        })


        this.bindPagination();
    }


    bindPagination () {

        this.paginate.forEach((item, idx) => {
            item.addEventListener('click', e => {
                e.preventDefault();
                const paginate = item.getAttribute('data-paginate');

                if (item.getAttribute('disabled')) { return; }

                switch(paginate) {
                    case 'prev':
                        currPage--;
                        break;
                    case 'next':
                        currPage++;
                        break;
                    case 'first':
                        currPage = 1;
                        break;
                    case 'last':
                        currPage = maxPage;
                        break;
                }

                if (currPage <= 1) { currPage = 1; }
                if (currPage > maxPage) { currPage = maxPage; }

                togglePreloader();

                setTimeout(() => {
                    this.current.innerHTML = currPage;
                    this.loadArticles(currPage);
                    this.disablePagination(currPage, maxPage);
                }, 350);

                return currPage;
            })
        });

    }


    handleSelection (item) {
        let _val = item.getAttribute('data-filter-id');

        this.categoryItem.forEach(node => {
            node.classList.remove('is-selected');
        });

        item.classList.add('is-selected');

        this.categoryDropdown.val(_val).trigger('change');

        mapping.set('category', _val);
    }



    filterArticle (object = {}) {
        const val = Array.from(object);
        const URL = val[1] ? `type=${val[0][0]}&value=${val[0][1]}&type2=${val[1][0]}&value2=${val[1][1]}` : `type=${val[0][0]}&value=${val[0][1]}`;
        currPage = 1;

        newPromise = axios.get(`/api/article-list/filter/knowledge-library/?${URL}`)
            .then(response => {
                return response.data;
            })
            .then(data => {
                const klData = data.data;
                let appendMarkUp;

                this.container.innerHTML = '';

                for (let i = 0; i < klData.length; i++) {
                    appendMarkUp = renderKLTemp(klData[i]);
                    this.container.insertAdjacentHTML('beforeend', appendMarkUp);
                }

                return data;
            })
            .then(data => {
                togglePreloader();
                maxPage = data.last_page;

                this.current.innerHTML = currPage;
                this.total.innerHTML = maxPage;

                if (data.next_page_url == null && data.prev_page_url == null) {
                    this.pagination.classList.add('is-hidden');
                } else {
                    this.pagination.classList.remove('is-hidden');
                }

                newURL = data.next_page_url;

                return data;
            })
            .then(data => {
                const initFormat = mapping.size < 2 && mapping.keys().next().value == 'format';
                const initCategory = mapping.size < 2 && mapping.keys().next().value == 'category';

                if (data.formats.length > 0) { this.disableFilterItems(this.formatDropdown, data.formats, initFormat); }
                if (data.categories.length > 0) { this.disableFilterItems(this.categoryDropdown, data.categories, initCategory); }

                if (data.data.length < 1) {
                    this.container.innerHTML = '';
                    this.container.insertAdjacentHTML('beforeend', noResultsTemp('Your filter returned no results.', 'Try changing your filters.'));
                }
            })
            .catch(error => {
                togglePreloader();
                this.container.innerHTML = '';

                this.pagination.classList.add('is-hidden');

                console.error(error);
            });
    }


    loadArticles (num = 1, init = true) {

        const URL = newURL ? newURL.replace('page=2', `page=${num}`) : `/api/article-list/knowledge-library?page=${num}`;

        newPromise = axios.get(URL)
            .then(response => {
                return response.data;
            })
            .then(data => {
                const klData = data.data;
                let appendMarkUp;

                this.container.innerHTML = '';

                for (let i = 0; i < klData.length; i++) {
                    appendMarkUp = renderKLTemp(klData[i]);

                    this.container.insertAdjacentHTML('beforeend', appendMarkUp);
                }

                return data;
            })
            .then(data => {
                togglePreloader();
                maxPage = data.last_page;

                // this.current.innerHTML = 1;
                this.total.innerHTML = maxPage;

                if (data.next_page_url == null && data.prev_page_url == null) {
                    this.pagination.classList.add('is-hidden');
                } else {
                    this.pagination.classList.remove('is-hidden');
                }

                return data;
            })
            .then(data => {
                this.disableFilterItems(this.formatDropdown, data.formats);
                this.disableFilterItems(this.categoryDropdown, data.categories);
            })
            .catch(error => {
                console.error(error);
            })
    }



    // DISABLE FILTER ITEMS
    disableFilterItems (dropdown, data, init = false) {
        const myDropdown = Array.from(dropdown[0].querySelectorAll('option'));

        if (init) { return; }

        // remove all disabled attribute
        myDropdown.forEach(item => {
            if (!item.classList.contains('is-disabled')) {
                item.removeAttribute('disabled');
            }
        });

        if (data) {
            const filteredArray = filterArray(myDropdown, data);

            filteredArray.forEach(item => {
                if (item.value != dropdown.val() && item.value != '') {
                    item.setAttribute('disabled', '');
                }
            });
        }


        dropdown.select2('destroy')
            .select2({
                dropdownParent: dropdown.parent()
            });
    }


    disablePagination (curr, max) {
        this.paginate.forEach(item => {
            const paginate = item.getAttribute('data-paginate');
            item.removeAttribute('disabled');
            if (curr == 1) {
                if (paginate == 'first' || paginate == 'prev') { item.setAttribute('disabled', true); }
            } else if (curr == maxPage) {
                if (paginate == 'last' || paginate == 'next') { item.setAttribute('disabled', true); }
            } else {
                item.removeAttribute('disabled');
            }
        })
    }


    getUrlParam (name) {
        name = name.replace(/[\[\]]/g, "\\$&");
        var url = window.location.href,
            regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);

        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }


    loadDefaultArticles () {
        let category = this.getUrlParam('category');

        if (category) {
            let items = Array.from(this.element.querySelectorAll('.js-kl-category[data-filter-id="'+ category +'"]'));

            if (items.length) {
                this.handleSelection(items[0]);
            }
        }
    }


}
